<div class="app-social-share mt-4  text-center" [ngStyle]="{'color': dynamicSettingsData?dynamicSettingsData.form_font_secondary_color : '','background-color': dynamicSettingsData.form_bg_color ? dynamicSettingsData.form_bg_color :  null, 'font-family': dynamicSettingsData.font_family ? dynamicSettingsData.font_family : null  }"
    [ngClass]="{'mt-0':router.url.includes('event'),'p-15':router.url.includes('event'),'p-2':productsList?.length >0,'p-4':productsList?.length<=0}">
    <div>
        <a class="share-event-divs spacing" [ngStyle]="{'color': dynamicSettingsData?.event_font_secondary_color }" [ngClass]="{'spacing-1 ':productsList?.length>0}"(click)="onDisplay()">
            <span class="shareicons">
                <!-- <img [src]="assets_url + 'embed.svg'" width="56" class="embed-icon"> -->
                <div class="embed-icon" [ngStyle]="{'color': dynamicSettingsData?.event_button_bg_secondary_color }"><app-svg [icon]="'embed'"></app-svg></div>
            </span>
            <span [ngStyle]="{'color': dynamicSettingsData?dynamicSettingsData.form_font_secondary_color : '' }" class="mt-3 fs-10 ff linkname">Embed</span>
        </a>
        <a class="share-event-divs spacing" [ngClass]="{'spacing-1 ':productsList?.length>0}" [ngStyle]="{'color': dynamicSettingsData?.event_font_secondary_color }">
            <span class="shareicons facebook" shareButton="facebook" #fbBtn="shareButton">
                <fa-icon *ngIf="fbBtn" [icon]="fbBtn.icon" class="icons"></fa-icon>
            </span>
            <span [ngStyle]="{'color': dynamicSettingsData?dynamicSettingsData.form_font_secondary_color : '' }" class="mt-3 fs-10 ff linkname">Facebook</span>
        </a>
        <a class="share-event-divs spacing" [ngClass]="{'spacing-1 ':productsList?.length>0}" [ngStyle]="{'color': dynamicSettingsData?.event_font_secondary_color }"shareButton="twitter" #twtBtn="shareButton">
            <span class="shareicons twitter">
                <app-directive-svg [icon]="'x-icon'"></app-directive-svg>
                <!-- <fa-icon *ngIf="twtBtn" [icon]="twtBtn.icon" class="icons"></fa-icon> -->
            </span>
            <span [ngStyle]="{'color': dynamicSettingsData?dynamicSettingsData.form_font_secondary_color : '' }"  class="mt-3 fs-10 ff linkname">Twitter</span> </a>
        <a class="share-event-divs" [ngStyle]="{'color': dynamicSettingsData?.event_font_secondary_color }">
            <span class="shareicons linkedin " shareButton="linkedin" #inBtn="shareButton">
                <fa-icon *ngIf="inBtn" [icon]="inBtn.icon" class="icons"></fa-icon>
            </span>
            <span [ngStyle]="{'color': dynamicSettingsData?dynamicSettingsData.form_font_secondary_color : '' }" class="mt-3 fs-10 ff linkname">Linkedin</span>
        </a>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="25%">
            <button class="btn-embed" (click)="onDisplay()">
                <img src="assets/embed.svg" class="embed-icon" height="56" width="56">
                <p class="mt-1 fs-10 ff">Embed</p>
            </button>
        </div>
        <div fxFlex="25%">
            <button mat-fab shareButton="facebook" #fbBtn="shareButton" [style.backgroundColor]="fbBtn?.color">
                <fa-icon *ngIf="fbBtn" [icon]="fbBtn.icon" size="lg" class="icons"></fa-icon>
            </button>
        </div>
        <div fxFlex="25%">
            <button mat-fab shareButton="twitter" #twtBtn="shareButton" [style.backgroundColor]="twtBtn?.color">

            </button>
        </div>
        <div fxFlex="25%">
            <button mat-fab shareButton="linkedin" #inBtn="shareButton" [style.backgroundColor]="inBtn?.color">

            </button>
        </div>
    </div> -->

    <div class="bg-gray ff mt-4"
    [ngStyle]="{'background': router.url.includes('/stream/')? dynamicSettingsData?.event_bg_secondary_color : dynamicSettingsData?.event_bg_primary_color, 'color': router.url.includes('/stream/') ? dynamicSettingsData?.event_font_secondary_color : dynamicSettingsData?.event_font_primary_color }"
        [ngClass]="{'mt-15':router.url.includes('event')}" *ngIf="!isShow">
        {{textboxUrl}}
        <span> 
            <button class="copy-btn fw-bold" id="btnCopyClip" (click)="copyToClipboard('text-box')" [ngStyle]="{'color': dynamicSettingsData?.event_font_secondary_color }">
                COPY
            </button>
        </span>
    </div>
    <div class="bg-gray ff mt-4" *ngIf="isShow" [ngStyle]="{'background': router.url.includes('/stream/')? dynamicSettingsData?.event_bg_secondary_color : dynamicSettingsData?.event_bg_primary_color, 'color': router.url.includes('/stream/') ? dynamicSettingsData?.event_font_secondary_color : dynamicSettingsData?.event_font_primary_color }">
        <textarea [ngStyle]="{'color': dynamicSettingsData?dynamicSettingsData.form_font_secondary_color : '' }">{{textAreaUrl}}</textarea>
        <span>
            <button [ngStyle]="{'color': dynamicSettingsData?dynamicSettingsData.form_font_secondary_color : '' }" class="copy-btn fw-bold copy-button" id="btnCopyClip" (click)="copyToClipboard('text-area')">
                COPY
            </button>
        </span>
    </div>
</div>